<template>
    <div>
        <span :style="{color: getColor }">
            ({{ mapPercentRow('percent') }}%, {{ mapCountRow('count') }})
        </span>
    </div>
</template>

<script>

import ValueChecker from "../../services/ValueChecker";

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        config: {
            type: Object,
            default: function() {
                return {
                    countIndex: undefined,
                    percentIndex: undefined,
                    totalIndex: undefined,
                }
            }
        },
        routeName: {
            type: String
        },
        row: {
            type: Object,
        }
    },
    data() {
        return {

        };
    },
    computed: {
        getColor() {
            return this.config.color ? this.config.color : '';
        },
    },
    mounted() {
    },
    methods: {
        calculatePercent(value, total) {
            if (total > 0) {
                return Math.round((value / total * 100 + Number.EPSILON) * 100) / 100;
            }
        },
        mapCountRow() {
            let countIndex = this.config.countIndex;

            if (!ValueChecker.isUndefinedOrNull(countIndex)) {
                return this.row[countIndex];
            }

            return this.mapRow('count');
        },
        mapPercentRow() {
            let percentIndex = this.config.percentIndex;

            if (!ValueChecker.isUndefinedOrNull(percentIndex)) {
                return this.row[percentIndex];
            }

            let totalIndex = this.config.totalIndex;
            let total = this.row[totalIndex];
            let percent = 0;

            if (total > 0) {
                let value = this.row[this.column.data];
                return this.calculatePercent(value, total);
            }

            return percent;
        },
        mapRow(value) {
            let columnIndex = this.column.data;

            return this.row[`${columnIndex}_${value}`];
        }
    }
}
</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// PercentOfTotalComponent.vue?6fc195e6